// context/MasterContext.js
import React, { createContext, useContext, useEffect, useReducer } from "react";
import { toast } from "react-toastify";
import apiCall from "../api";
import { masterReducer, initialMasterState } from "../reducers/masterReducer";
import { useAuth } from "./AuthProvider";

const API_COURSE_LIST = "course-list";

// Create context
const MasterContext = createContext();

// Provider
const MasterProvider = ({ children }) => {
  const [masterState, masterDispatch] = useReducer(masterReducer, initialMasterState);
  const { isLoggedIn, user } = useAuth();

 useEffect(() => {
    if (!isLoggedIn || !user?.token) return;

    const fetchData = async () => {
      try {
        const response = await apiCall({
          url: API_COURSE_LIST,
          method: "GET",
        });

        if (response?.data?.message === "Invalid Access Token") {
          console.warn("Invalid token");
        } else if (response?.status === 200) {
          masterDispatch({
            type: "SET_COURSE_LIST",
            payload: response.data?.course_summary || [],
          });
        } else {
          toast.error("Unexpected error while fetching course list.");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        toast.error("Network error. Please try again.");
      }
    };

    fetchData();
  }, [isLoggedIn, user?.token]);

  return (
    <MasterContext.Provider  value={{
    courseList: masterState.courseList || [],
  }}>
      {children}
    </MasterContext.Provider>
  );
};

// Custom hook
export const useMaster = () => {
  const context = useContext(MasterContext);
  if (!context) throw new Error("useMaster must be used within a MasterProvider");
  return context;
};

export default MasterProvider;
